import { getInstance, useFsTheme } from '@fs/utils';
import {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
// import { checkPermission } from './utils';
import { UIMatch, useMatches, useNavigate } from 'react-router-dom';
import { RouteHandle } from 'src/routes/type';

interface FsUserPermissionContextProps {
  permissions: string[] | undefined;
  isLoading: boolean;
  hasPermission: (permission?: string[]) => boolean;
  refreshPermissions: () => void;
}

const FsUserPermissionContext = createContext<
  FsUserPermissionContextProps | undefined
>(undefined);

export const useUserPermission = () => {
  const context = useContext(FsUserPermissionContext);
  if (!context) {
    throw new Error(
      'useUserPermission must be used within a FsUserPermissionContext'
    );
  }
  return context;
};

export const FsUserPermissionContextProvider = ({
  children,
}: PropsWithChildren) => {
  const { language } = useFsTheme();
  const { instance } = getInstance({ language });
  const [permissions, setPermissions] = useState<string[] | undefined>(
    undefined
  );
  const matches = useMatches() as UIMatch<undefined, RouteHandle>[];
  const navigateTo = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const currentRoute = matches[matches.length - 1];

  const hasPermission = useCallback(
    // (permission?: string[]) => {
    //   if (!permission || !permissions) return true;
    //   else if (permission.length === 0) return false;
    //   else return permission.some((per) => checkPermission(per, permissions));
    // },
    () => true,
    // [permissions]
    []
  );

  const getData = useCallback(async () => {
    setIsLoading(true);
    // const res = await instance('/v1/panel/getcurrentuserpermissions');
    setPermissions(
      // res?.data?.data?.userPermissions ? [...res.data.data.userPermissions] : []
      []
    );
    setIsLoading(false);
  }, [instance]);

  const refreshPermissions = useCallback(() => {
    getData();
  }, []);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    // if (!hasPermission(currentRoute.handle.permissions)) navigateTo('/');
  }, [currentRoute, hasPermission, navigateTo, permissions]);

  const contextValue = useMemo(
    () => ({
      permissions,
      hasPermission,
      isLoading,
      refreshPermissions,
    }),
    [permissions, hasPermission, isLoading, refreshPermissions]
  );

  return (
    <FsUserPermissionContext.Provider value={contextValue}>
      {children}
    </FsUserPermissionContext.Provider>
  );
};
